import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import PromoRadioCheckedIcon from "./Icons/PromoRadioChecked";
import PromoRadioUncheckedIcon from "./Icons/PromoRadioUnchecked";

import { translate } from "admin-on-rest";

const style = {
    backgroundColor: "#FFF",
    padding: 10,
    boxSizing: "border-box",
    border: "1px solid #E7E7E7",
    margin: 0,
    display: "block",
    width: "100%"
}

export class RadioButtonGroupInput extends Component {
    handleChange = (event, value) => {
        this.props.input.onChange(value);
    };



    renderRadioButton = choice => {
        const {
            optionText,
            optionValue,
            translate,
            translateChoice,
            disabled
        } = this.props;
        const choiceName = React.isValidElement(optionText) // eslint-disable-line no-nested-ternary
            ? React.cloneElement(optionText, { record: choice })
            : typeof optionText === 'function'
              ? optionText(choice)
              : get(choice, optionText);
        
        const isChecked = this.props.input.value === choice.id ? true : false;
        const checkedStyle = isChecked ? {backgroundColor: "#DFDFDF"} : null;

        return (
            <RadioButton
                key={get(choice, optionValue)}
                label={
                    translateChoice ? (
                        translate(choiceName, { _: choiceName })
                    ) : (
                        choiceName
                    )
                }
                value={get(choice, optionValue)}
                disabled={disabled}
                checkedIcon={<PromoRadioCheckedIcon />}
                uncheckedIcon={<PromoRadioUncheckedIcon />}             
                style={{
                    ...style, 
                    ...checkedStyle
                }}
            />
        );
    };

    render() {
        const {
            source,
            input,
            choices,
            options,
            elStyle,
        } = this.props;

        return (
            <RadioButtonGroup
                onChange={this.handleChange}
                name={source}
                defaultSelected={input && input.value}
                valueSelected={input && input.value}
                style={elStyle}
                {...options}
            >
                {choices.map(this.renderRadioButton)}
            </RadioButtonGroup>
        );
    }
}

RadioButtonGroupInput.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.object),
    elStyle: PropTypes.object,
    input: PropTypes.object,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    options: PropTypes.object,
    optionText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.element,
    ]).isRequired,
    optionValue: PropTypes.string.isRequired,
    resource: PropTypes.string,
    source: PropTypes.string,
    translate: PropTypes.func.isRequired,
    translateChoice: PropTypes.bool.isRequired,
};

RadioButtonGroupInput.defaultProps = {
    addField: true,
    choices: [],
    options: {},
    optionText: 'name',
    optionValue: 'id',
    translateChoice: true,
};

export default translate(RadioButtonGroupInput);



// WEBPACK FOOTER //
// ./src/components/CRM/Form/RadioButtonGroupInput.js